import { ButtonVariant, Dialog, Text } from "@merge-api/merge-javascript-shared";

interface Props {
  selectedObjectType: string;
  associatedObjectsName?: string | null;
  show: boolean;
  onHide: () => void;
  isLoading: boolean;
  onConfirm: () => void;
  objectName?: string | null;
}

function ArchiveConfirmationModal({
  selectedObjectType,
  show,
  onHide,
  isLoading,
  onConfirm,
  objectName = null,
}: Props) {
  return (
    <Dialog
      title="Confirm archive"
      onClose={onHide}
      onPrimaryButtonClick={onConfirm}
      primaryButtonText="Confirm"
      primaryButtonVariant={ButtonVariant.DangerFilled}
      primaryButtonLoading={isLoading}
      secondaryButtonText="Cancel"
      onSecondaryButtonClick={onHide}
      open={show}
      variant="md"
    >
      <div className="flex flex-col gap-y-3">
        <Text>Are you sure you want to archive this {selectedObjectType}?</Text>
        <Text>{objectName && <b>{objectName}</b>}</Text>
      </div>
    </Dialog>
  );
}

export default ArchiveConfirmationModal;
